document.addEventListener('alpine:init', () => {
  Alpine.data('ThemeModule_GiftWrap', (initialInCart, initialKey, variantId) => {
    return {
      // Stato iniziale passato dal Liquid
      isGiftWrapInCart: initialInCart,
      giftWrapLineItemKey: initialKey || '',
      variantId: variantId,
      loading: false,

      // Detect if we're on cart page or drawer
      get isCartPage() {
        return window.location.pathname === '/cart' || window.location.pathname.includes('/cart');
      },

      // Get sections based on context
      get sections() {
        if (this.isCartPage) {
          return 'cart-items,cart-footer,cart-item-count,cart-live-region';
        } else {
          return 'drawer-cart-items,drawer-cart-footer,cart-item-count,cart-live-region';
        }
      },

      init() {
        // Quando il tema aggiorna il carrello dopo un add
        window.addEventListener('switch:cart:afteradditem', (e) => {
          if (!e.detail || !e.detail.response) return;
          this.syncFromResponse(e.detail.response);
        });

        // Quando il tema aggiorna il carrello dopo un cambio qty / remove
        window.addEventListener('switch:modalcart:cartqtychange', (e) => {
          if (!e.detail || !e.detail.response) return;
          this.syncFromResponse(e.detail.response);
        });
      },

      /**
       * Aggiorna lo stato interno leggendo la risposta JSON del carrello
       */
      syncFromResponse(response) {
        if (!response || !response.items) return;

        const item = response.items.find((i) => i.variant_id == this.variantId);

        if (item) {
          this.isGiftWrapInCart = true;
          this.giftWrapLineItemKey = item.key;
        } else {
          this.isGiftWrapInCart = false;
          this.giftWrapLineItemKey = '';
        }
      },

      /**
       * Handler del toggle checkbox
       */
      async toggleGiftWrap(checked) {
        if (this.loading) return;

        this.loading = true;

        try {
          if (checked) {
            await this.addGiftWrap();
          } else {
            await this.removeGiftWrap();
          }
        } catch (err) {
          console.error('Gift wrap error:', err);
          // rollback dello stato in caso di errore
          this.isGiftWrapInCart = !checked;
        } finally {
          this.loading = false;
        }
      },

      /**
       * Aggiunge il gift wrap al carrello
       */
      async addGiftWrap() {
         const formData = new FormData();
         formData.append('id', this.variantId);
         formData.append('quantity', 1);
         formData.append('sections', this.sections);
         formData.append('sections_url', window.location.pathname);

        const addUrl =
          (window.theme &&
            window.theme.routes &&
            window.theme.routes.cart_add_url) ||
          '/cart/add.js';

        const response = await fetch(addUrl, {
          method: 'POST',
          body: formData,
          credentials: 'same-origin',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            Accept: 'application/javascript',
          },
        });

        const data = await response.json();

        if (data.status) {
          throw new Error(
            data.description || data.message || 'Errore nell’aggiunta del gift wrap'
          );
        }

        // aggiorna stato interno
        this.syncFromResponse(data);

        // Lasciamo che sia il tema (cart-items.js + cart-footer.js) ad aggiornare il drawer
        document.body.dispatchEvent(
          new CustomEvent('switch:cart:afteradditem', {
            bubbles: true,
            detail: { response: data },
          })
        );
      },

      /**
       * Rimuove il gift wrap dal carrello
       */
      async removeGiftWrap() {
        // Se non abbiamo la key, cerchiamo prima nel carrello
        if (!this.giftWrapLineItemKey) {
          await this.findGiftWrapInCart();
        }
        if (!this.giftWrapLineItemKey) {
          console.warn('Gift wrap non trovato nel carrello');
          return;
        }

        const removedKey = this.giftWrapLineItemKey; // salviamo la key prima di eventuali reset

        const changeUrl =
          (window.theme &&
            window.theme.routes &&
            window.theme.routes.cart_change_url) ||
          '/cart/change.js';

        const response = await fetch(changeUrl, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/javascript',
          },
           body: JSON.stringify({
             id: removedKey,
             quantity: 0,
             sections: this.sections,
             sections_url: window.location.pathname,
           }),
        });

        const data = await response.json();

        // aggiorna stato interno in base alla risposta del carrello
        this.syncFromResponse(data);

        // individuiamo la riga del carrello corrispondente, se ancora presente nel DOM
        const lineItemEl = document.querySelector(
          `[data-cart-item-key="${removedKey}"]`
        );

        // notifichiamo al tema che il carrello è cambiato:
        // cart-items.js aggiornerà gli items,
        // cart-footer.js aggiornerà il footer
        document.body.dispatchEvent(
          new CustomEvent('switch:modalcart:cartqtychange', {
            bubbles: true,
            detail: {
              response: data,
              // inviamo come "origine" la riga del carrello (o il wrapper items come fallback)
              originalTarget:
                lineItemEl || document.querySelector('[data-cart-items]'),
            },
          })
        );
      },

      /**
       * Cerca il gift wrap nel carrello corrente
       */
      async findGiftWrapInCart() {
        const cartUrl =
          (window.theme &&
            window.theme.routes &&
            window.theme.routes.cart_url) ||
          '/cart.js';

        const response = await fetch(cartUrl, {
          method: 'GET',
          credentials: 'same-origin',
          headers: {
            Accept: 'application/json',
          },
        });

        const cart = await response.json();

        if (cart.items && cart.items.length) {
          const item = cart.items.find((i) => i.variant_id == this.variantId);
          if (item) {
            this.isGiftWrapInCart = true;
            this.giftWrapLineItemKey = item.key;
          } else {
            this.isGiftWrapInCart = false;
            this.giftWrapLineItemKey = '';
          }
        }
      },
    };
  });
});